import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

import {
  Footer as BaseFooter,
  ModalHead as BaseModalHead,
  OrderDetailsScrollContainer as BaseOrderDetailsScrollContainer,
} from './details-modal.styled.default';

export * from './details-modal.styled.default';

export const Footer = styled(BaseFooter)`
  background-color: ${p => p.theme.token('background-pattern')};
`;

export const ModalHead = styled(BaseModalHead)`
  border-bottom: none;
  background-color: ${p => p.theme.token('background-pattern')};

  h2 {
    font: ${brandFont.headerOne};
  }
`;

export const StyledCartEntries = styled.div`
  display: grid;
  grid-template-columns: auto 4.5rem 0.5fr;
  align-items: stretch;
  border-top: 1px solid ${p => p.theme.token('border-color-default')};
`;

export const OrderDetailsScrollContainer = styled(BaseOrderDetailsScrollContainer)`
  background-color: ${p => p.theme.token('background-pattern')};
`;
